exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-container[data-v-7c4a04a0]{min-height:600px}.top-container .el-tabs[data-v-7c4a04a0]{position:fixed;z-index:9;background:#fff;width:100%;padding:20px 20px 0;margin-top:0 !important}", ""]);

// exports
